<template>
  <div v-if="item && showRhinoRackStock && stockStatusText !== false">
    <div v-if="isFetchCompleted" :class="enabled == true ? 'pricing_header row cursor_pointer' : 'pricing_header row'" v-on:click="toggleOpen = !toggleOpen">
      <div :class="enabled == true ? 'left col-6' : 'left col-12'" v-if="prices && prices.length && prices.length == 1 && !cartNoAccess">
        <b>{{ label_stock_availability }}</b>
        <div class="availability" :class="stockStatusIcon"></div>
        {{ stockStatusText }}
      </div>
      <div :class="enabled == true ? 'left col-6' : 'left col-12'" v-if="prices && prices.length && prices.length > 1 && !cartNoAccess">
        <b>{{ label_stock_availability }}</b>
        <div class="availability" :class="stockStatusIcon"></div>
        {{ stockStatusText }}
      </div>
      <div :class="enabled == true ? 'left col-6' : 'left col-12'" v-if="prices && prices.length && cartNoAccess">
        <b>Your Pricing</b>
      </div>
      <div class="right col-6" v-if="item_price > 0 && userType == 'B2B' && item" >
        <span v-if="!toggleOpen">{{ label_expand }}</span> <i class="icon icon-down" v-if="!toggleOpen"></i><i class="icon icon-up" v-if="toggleOpen"></i>
      </div>
    </div>

    <div class="pricing_body row" v-if="item_price > 0 && toggleOpen && userType == 'B2B' && item">
      <div class="col-12 price_title" v-if="!priceschedule.length">
        <b>{{ formatNumber(item_price) }} {{ getPriceSuffix }}</b>
      </div>
      <div v-if="!noBulkBuyDiscount">
        <div class="col-12 price_title" v-if="priceschedule.length">
          <b>{{ label_product_price_breakdown }}</b>
        </div>
        <div class="price_item" :class="getPriceCountClass(priceschedule)" v-for="(item, index) in priceschedule" :key="index">
          <div class="ranges">{{ item.minimumquantity }}{{ item.maximumquantity == '+' ? '+' : "-" + item.maximumquantity }}</div>
          <div class="values">{{ formatNumber(item.price) }} {{ getPriceSuffix }}</div>
        </div>
      </div>
      <div v-if="noBulkBuyDiscount">
        <div class="values">{{ formatNumber(priceschedule[0].price) }} {{ getPriceSuffix }}</div>
      </div>
      <div class="estimate">{{ label_estimated }}</div>
    </div>
    <out-of-stock-notification :product-id="product_id" :sitekey="sitekey" :item="item"  v-if="((!item ||!item.isinstock || areComponentsOutOfStock ) && !isAlwaysInStock )&& isWaitListActive"></out-of-stock-notification>
  </div>
</template>

<style scoped>
  .pricing_header {
    background-color: #EAEAEA;
    border: 1px solid #D3D3D3;
    padding: 10px 0px;

  }
  .cursor_pointer{
    cursor: pointer;
  }
  .pricing_body {
    border: 1px solid #D3D3D3;
    margin-top: -1px;
  }
  .pricing_header .right {
    text-align: right;
  }
  .pricing_header i {
    font-size: 10px;
    vertical-align: middle;
  }
  .availability {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 5px;
  }
  .in_store {
    background-color: green;
  }

  .available_for_backorder {
    background-color: darkorange;
  }
  .out_of_stock {
    background-color: darkred;
  }
  .ranges {
    background-color: #F1F1F1;
    font-weight: bold;
  }
  .items_1 {
    width: 100%;
    float: left;
  }
  .items_2, .items_4, .items_5 {
    width: 50%;
    float: left;
  }
  .items_3, .items_6 {
    width: 33.33333%;
    float: left;
  }
  .ranges, .values {
    padding: 7px 15px;
    text-align: center;
  }
  .price_title {
    padding: 7px 15px;
  }
  .estimate {
    padding: 4px 15px;
    color: #555;
    font-size: 13px;
  }
</style>

<script>
import availabilityMixin from "../../mixins/availabilityMixin";
import OutOfStockNotification from "../out-of-stock-notification.vue";
import { getRegionConfig } from "../../utils/regionConfig";
import { buildNetSuiteStockUrl, buildNetSuiteChildComponentsUrl } from "../../utils/netsuiteUrlBuilder";
import { PricingService } from "../../services/pricingService";
import { AvailabilityService, StockStatus } from "../../services/availabilityService";
import { formatPrice, getPriceSuffix } from "../../utils/priceFormatter";

export default {
  name: "dealer-pricing",
  mixins: [availabilityMixin],
    data() {
      return {
        enabled: false,
        prices: [],
        item_price: 0,
        priceschedule: [],
        item: null,
        availabilityAU : null,
        ns_session_var: window.ns_session_var,
        tax: window.tax,
        currency: window.currency,
        culture: window.culture,
        country: window.country,
        toggleOpen: false,
        areComponentsOutOfStock: false,
        product_category: '',
        isFetchCompleted: false,
        auStockValue: 0,
        itemStockCode: this.stock_code,
      };
    },
    computed: {
      locId() {
        return getRegionConfig(window.culture).locId;
      },
      regionId() {
        return getRegionConfig(window.culture).regionId;
      },
    },
    components: {
      OutOfStockNotification
    },
    props: {
      sitekey:{
        type: String
      },
      netsuite_url: {
        type: String
      },
      netsuite_parent_id :{
        type: String,
      },
      netsuite_parent_id_new :{
        type: String,
      },
      netsuite_id: {
        type: String
      },
      package_components: {
        type: String
      },
      parent_status: {
        type: String
      },
      parent_isinstock: {
        type: String
      },
      parent_isbackorderable: {
        type: String
      },
      childactivestatus: {
        type: String
      },
      childbackorderablestatus: {
        type: String
      },
      product_id: {
        type: String
      },
      item_brand: {
        type: String,
        default: "Rhinorack"
      },
      components: {
        type: Array
      },
      product_title: {
        type: String
      },
      category: {
        type: Object
      },
      price: {
        type: Number,
        required: true
      },
      stock_code: {
        type: String
      },
      stock_code_new: {
        type: String
      },
      is_stock_waitlist_active: {
        type: String
      },
      is_spare_part_enabled: {
        type: String
      },
      is_always_in_stock: {
        type: String
      },
      label_expand: {
        type: String,
        default: "Expand for dealer pricing"
      },
      label_product_price_breakdown: {
        type: String,
        default: "Product Price Breakdown"
      },
      label_estimated: {
        type: String,
        default: "Prices are estimated, further discounts may apply at checkout."
      },
      ga_tracking_category: {
        type: String,
        default: "view_item"
      },
    },
    mounted(){
      this.filterCategory();
      this.loadPricing();
      this.isFetchCompleted = true;
    },
    computed: {
      userType() {
        var ret = this.$store.getters["auth/userType"];
        if (!this.enabled) {
          this.enabled = true;
        }
        return ret;
      },
      cartUrl() {
        var t = parseInt(Date.now() / 1000);
        if (this.components && this.components.length == 0) {
          return this.netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + this.ns_session_var + "&fieldset=details&n=2&region=" + this.regionId + "&currency=" + this.currency + "&id=" + this.netsuite_id + `&t=` + t;
        } else {
          var ids = this.components.map((item, index) => {
            return item.product.netSuiteId;
          });
          ids.push(this.netsuite_id);
          return this.netsuite_url + "api/items?&include=facets&pricelevel=5&c=" + this.ns_session_var + "&fieldset=details&n=2&region=" + this.regionId + "&currency=" + this.currency + "&id=" + ids.join(',') + `&t=` + t;
        }
      },
      cartNoAccess() {
        return false; // RRI-817 Temp Fix this.$store.getters["auth/cartNoAccess"];
      },
      isWaitListActive() {
        return Boolean(Number(this.is_stock_waitlist_active));
      },
      isAlwaysInStock() {
        return this.is_always_in_stock ? Boolean(Number(this.is_always_in_stock)) : false;
      },
      showRhinoRackStock() {
        return this.$store.getters["auth/showRhinoRackStock"];
      },
      noBulkBuyDiscount() {
        return this.$store.getters["auth/noBulkBuyDiscount"];
      },
      getPriceSuffix() {
        return getPriceSuffix(this.culture);
      }
    },
    methods: {
      filterCategory(){
        if (this.category && this.category.title) {
          this.product_category = this.category.title;
        }
      },
      getPriceCountClass(prices) {
        return PricingService.getPriceCountClass(prices);
      },
      formatNumber(num) {
        return formatPrice(num, this.culture, this.currency, this.country, 1);
      },
      async loadPricing() {
        const apiData = await axios.get(this.cartUrl, { withCredentials: true });
        this.prices = apiData.data.items;
        
        if (this.prices.length === 1) {
          // Single product
          const result = PricingService.processSingleProductPrice(this.prices[0]);
          this.item_price = result.item_price;
          this.priceschedule = result.priceschedule;
          this.item = result.item;
        } else {
          // Package product
          const result = PricingService.calculatePackagePrice(this.prices, this.components, this.netsuite_id);
          this.item_price = result.item_price;
          this.priceschedule = result.priceschedule;
          this.item = result.item;
        }
      },
      isSparePartEnabled() {
        return Boolean(Number(this.is_spare_part_enabled));
      }
    }
  };
</script>


